
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/journey",
      function () {
        return require("private-next-pages/journey/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/journey"])
      });
    }
  